import { Button, Card, CardContent, Grid, Typography, Tooltip, IconButton, Box, CircularProgress, TextField, Collapse } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import StopCircleIcon from '@mui/icons-material/StopCircle';
import React, { useEffect, useState } from 'react';
import { finFichaje, getFichaje, inicioFichaje } from '../../services/apis';
import { useNavigate } from 'react-router-dom';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import PunchClockIcon from '@mui/icons-material/PunchClock';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';

export const Fichar = () => {
    const [inciado, setIniciado] = useState(false);
    const [segundos, setSegundos] = useState("");
    const [localizacion, setLocalizacion] = useState({});
    const [tiempoTranscurrido, setTiempoTranscurrido] = useState(0);
    const [turnos, setTurnos] = useState([]); // Para almacenar los turnos del día
    const [ultimaEntrada, setUltimaEntrada] = useState(null); // Para mostrar la última entrada o salida
    const [loaded, setLoaded] = useState(false);
    const [descripcion, setDescripcion] = useState("");
    const [desplegado, setDesplegado] = useState(false);
    const [ubicacionHabilitada, setUbicacionHabilitada] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [open, setOpen] = useState(false);

    const Navigate = useNavigate();

    const obtenerFechaActual = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    const obtenersoloFechaActual = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const finalizarFichaje = async () => {
        try {
            const fechaActual = obtenerFechaActual();

            const response = await finFichaje({ "fecha": fechaActual, "localizacion": localizacion, "observacion": descripcion });
            setIniciado(false);
            setDescripcion("")
            consultarFichaje(); // Actualizar la vista después de finalizar
        } catch (error) {
            console.error("Error al finalizar fichaje:", error);
            localStorage.clear();
            Navigate("/login");
        }
    };
    const handleIntentoFichar = () => {
        if (!ubicacionHabilitada) {
            setOpenModal(true); // Mostrar el modal si no hay ubicación
        } else {
            iniciarfichaje(); // Ya tiene permisos
        }
    };
    const handleIntentoFinalizar = () => {
        if (!ubicacionHabilitada) {
            setOpenModal(true); // Mismo modal para pedir permiso
        } else {
            finalizarFichaje(); // Ya tiene permisos
        }
    };
    const sumarSegundos = (fichajes) => {
        if (Array.isArray(fichajes)) {
            const sumaTotal = fichajes.reduce((acumulador, fichaje) => {
                if (fichaje.hora_fin) {
                    return acumulador + parseInt(fichaje.total, 10);
                } else {
                    const horaActual = new Date();
                    const horaInicio = new Date(fichaje.hora_inicio);
                    const diferenciaSegundos = Math.floor((horaActual - horaInicio) / 1000);
                    acumulador += diferenciaSegundos;
                    setIniciado(true);
                }
                return acumulador;
            }, 0);
            setSegundos(sumaTotal);

            // Establecer el último fichaje
            if (fichajes.length > 0) {
                setUltimaEntrada(fichajes[fichajes.length - 1]);
            }
        }
    };

    const iniciarfichaje = async () => {
        const fechaActual = obtenerFechaActual();
        try {
            const response = await inicioFichaje({ "fecha": fechaActual, "localizacion": localizacion });
            setIniciado(true);
            consultarFichaje(); // Actualizar la vista después de iniciar
        } catch (error) {
            console.error("Error al iniciar el fichaje:", error);
            localStorage.clear();
            Navigate("/login");
        }
    };

    const consultarFichaje = async () => {
        const fechaActual = obtenersoloFechaActual();
        try {
            const response = await getFichaje(fechaActual);
            setTurnos(response.data); // Guardar los turnos completos del día
            sumarSegundos(response.data);
            setLoaded(true);
        } catch (error) {
            console.error("Error al consultar fichajes:", error);
            localStorage.clear();
            Navigate("/login");
        }
    };

    useEffect(() => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    setLocalizacion({ latitude, longitude });
                    setUbicacionHabilitada(true);
                },
                (error) => {
                    console.error(`Error Code = ${error.code} - ${error.message}`);
                    setUbicacionHabilitada(false);
                }
            );
        } else {
            console.error('Geolocation is not supported by this browser.');
        }
        consultarFichaje();
    }, []);

    const formatTime = (segundos) => {
        const horas = Math.floor(segundos / 3600);
        const minutos = Math.floor((segundos % 3600) / 60);
        const seg = segundos % 60;
        return `${String(horas).padStart(2, '0')}:${String(minutos).padStart(2, '0')}:${String(seg).padStart(2, '0')}`;
    };

    const formatHour = (dateTime) => {
        const time = new Date(dateTime);
        return `${String(time.getHours()).padStart(2, '0')}:${String(time.getMinutes()).padStart(2, '0')}`;
    };
    const solicitarUbicacionYContinuar = (accion) => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    setLocalizacion({ latitude, longitude });
                    setUbicacionHabilitada(true);
                    setOpenModal(false);
                    accion(); // Ejecutar la acción deseada
                },
                (error) => {
                    console.error("Permiso denegado:", error);
                    alert("No se pudo obtener la ubicación. Verifica los permisos en tu navegador.");
                    setOpenModal(false);
                }
            );
        } else {
            alert("Tu navegador no soporta geolocalización.");
            setOpenModal(false);
        }
    };

    const renderTooltipContent = () => (
        <div>
            <Typography variant="body2"><strong>Turnos del día:</strong></Typography>
            {turnos.map((turno, index) => (
                <Typography key={index} variant="body2">
                    {formatHour(turno.hora_inicio)} - {turno.hora_fin ? formatHour(turno.hora_fin) : 'En curso'}
                </Typography>
            ))}
            <Typography variant="body2" sx={{ mt: 1 }}>
                <strong>Jornada Total:</strong> {formatTime(segundos)}
            </Typography>
        </div>
    );

    useEffect(() => {
        let intervalo;
        if (inciado) {
            intervalo = setInterval(() => {
                setTiempoTranscurrido((prev) => prev + 1);
            }, 1000);
        }
        return () => clearInterval(intervalo);
    }, [inciado]);

    return (
        <Grid
            container
            xs={12}
            gap={1}
            direction="row"
            justifyContent="center"
            alignItems="center"
            className="fichaje-card fade-in2"
        >
            <Card
                sx={{ width: '100%', padding: 0.5, borderRadius: 3, boxShadow: 3, background: "var(--fondoTarjeta)" }}
            >
                <CardContent>
                    <>
                        {!loaded && (
                            <CircularProgress size={40} />
                        )}
                        {loaded && (
                            <>

                                <Grid
                                    container
                                    direction="column"
                                    justifyContent="center"
                                    alignItems="center"
                                    xs={12}
                                >
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="space-between"
                                        alignItems="center"
                                        xs={12}
                                    >
                                        <Typography variant="h5">
                                            Fichaje
                                        </Typography>

                                        <Tooltip
                                            disableFocusListener
                                            disableHoverListener
                                            disableTouchListener
                                            open={open}
                                            title={renderTooltipContent()}
                                            placement="bottom-start"
                                            slotProps={{
                                                popper: {
                                                    disablePortal: true,
                                                },
                                            }}
                                        >
                                            <IconButton size='small' onClick={() => setOpen(!open)}>
                                                <InfoIcon sx={{ fontSize: 30 }} />
                                            </IconButton>
                                        </Tooltip>
                                    </Grid>

                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="start"
                                        alignItems="center"
                                        xs={12}
                                    >
                                        {ultimaEntrada && (
                                            <>
                                                {
                                                    ultimaEntrada.hora_fin === null && (
                                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
                                                            <Typography variant="body1" color="green">Activo</Typography>
                                                            <FiberManualRecordIcon sx={{ color: 'green', fontSize: 20, mb: -0.1 }} />
                                                        </Box>
                                                    )
                                                }
                                                {ultimaEntrada.hora_fin !== null && (
                                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                        <Typography variant="body1" color="red"> No Activo</Typography>
                                                        <FiberManualRecordIcon sx={{ color: 'red', fontSize: 20, mb: -0.1 }} />
                                                    </Box>
                                                )}

                                            </>
                                        )}

                                        <Grid item xs={12} sx={{ mt: 2 }}>
                                            {ultimaEntrada && (
                                                <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    Última {ultimaEntrada.hora_fin ? "Salida" : "Entrada"}: {ultimaEntrada.hora_fin ? formatHour(ultimaEntrada.hora_fin) : formatHour(ultimaEntrada.hora_inicio)}
                                                    {/* Mostrar indicador "Activo" si está en curso */}
                                                </Typography>
                                            )}
                                        </Grid>



                                        <Typography variant="body2" color="text.secondary" marginBottom={2}>
                                            Realiza tu registro de asistencia aquí.
                                        </Typography>



                                    </Grid>




                                    {!inciado ? (
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            endIcon={<PlayCircleOutlineIcon sx={{ mt: -0.3 }} />}
                                            onClick={handleIntentoFichar}
                                            sx={{ mb: 1 }}
                                        >
                                            Fichar
                                        </Button>
                                    ) : (

                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="center"
                                            alignItems="center"
                                            xs={12}
                                            sx={{ mt: 0 }}
                                        >
                                            <Grid item xs={9}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    fullWidth
                                                    endIcon={<StopCircleIcon sx={{ mt: -0.3 }} />}
                                                    onClick={handleIntentoFinalizar}  // 👈 CAMBIO AQUÍ
                                                >
                                                    Salida
                                                </Button>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    fullWidth
                                                    // endIcon={desplegado ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                    onClick={() => setDesplegado(!desplegado)}
                                                >
                                                    &nbsp;{desplegado ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}&nbsp;
                                                </Button>
                                            </Grid>

                                            <Collapse in={desplegado} sx={{ minWidth: '100%', mt: 1 }}>
                                                <TextField
                                                    type="text"
                                                    id="dateInput"
                                                    name="fechaDesde"
                                                    label="Observación"
                                                    value={descripcion}
                                                    fullWidth
                                                    onChange={(e) => setDescripcion(e.target.value)} // Actualiza el estado con el valor ingresado
                                                >
                                                </TextField>
                                            </Collapse>
                                            {/* 
                                                {desplegado && (
                                                    <Grid container xs={12} justifyContent={'center'} marginTop={"1em"}>

                                                    </Grid>
                                                )} */}

                                        </Grid>
                                    )}

                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="small" // Tamaño pequeño
                                        name="descripcion"
                                        endIcon={<PunchClockIcon sx={{ mt: -0.3 }} />}
                                        onClick={() => Navigate("/fichajesusuario/0")}
                                        fullWidth
                                        sx={{ mt: 1, padding: '0.5em 1em', fontSize: '0.6em' }} // Ajusta el padding y el tamaño de fuente
                                    >
                                        Ver Todos
                                    </Button>

                                </Grid>
                            </>
                        )}
                    </>
                </CardContent>
                <Dialog open={openModal} onClose={() => setOpenModal(false)}>
                    <DialogTitle>Permitir acceso a tu ubicación</DialogTitle>
                    <DialogContent>
                        <Typography>
                            Necesitamos tu ubicación para registrar correctamente tu asistencia. Por favor, permite el acceso para continuar.
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setOpenModal(false)}>Cancelar</Button>
                        <Button
                            onClick={() => {
                                const accion = inciado ? finalizarFichaje : iniciarfichaje;
                                solicitarUbicacionYContinuar(accion);
                            }}
                            autoFocus
                        >
                            Permitir
                        </Button>
                    </DialogActions>
                </Dialog>
            </Card>
        </Grid>
    );
};
